import Router from "./clients-router";

import ClientsComponent from "./clients-component";
import ClientListComponent from "./client-list/client-list.component";
import ClientCreateComponent from "./client-create/client-create.component";
import ClientSettingsComponent from "./client-settings/client-settings.component";


const Module = angular
    .module("app.clients", [])
    .component("clients", ClientsComponent)
    .component("clientList", ClientListComponent)
    .component("clientCreate", ClientCreateComponent)
    .component("clientSettings", ClientSettingsComponent)
    .config(Router);

export default Module;


// WEBPACK FOOTER //
// ./sources/components/clients/clients-module.js